export const apiUrl = window.location.protocol + '//' + window.location.hostname;
export const wsProtocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
